/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreatePersonalAssetDto,
    CreatePersonalAssetDtoFromJSON,
    CreatePersonalAssetDtoToJSON,
    ImportPersonalAssetsResultDto,
    ImportPersonalAssetsResultDtoFromJSON,
    ImportPersonalAssetsResultDtoToJSON,
    PersonalAssetDto,
    PersonalAssetDtoFromJSON,
    PersonalAssetDtoToJSON,
    PersonalAssetImportTypeEnum,
    PersonalAssetImportTypeEnumFromJSON,
    PersonalAssetImportTypeEnumToJSON,
    PersonalAssetListDto,
    PersonalAssetListDtoFromJSON,
    PersonalAssetListDtoToJSON,
    PersonalAssetWithValueDto,
    PersonalAssetWithValueDtoFromJSON,
    PersonalAssetWithValueDtoToJSON,
    UpdatePersonalAssetDto,
    UpdatePersonalAssetDtoFromJSON,
    UpdatePersonalAssetDtoToJSON,
} from '../models';

export interface PersonalAssetControllerCreateRequest {
    createPersonalAssetDto: CreatePersonalAssetDto;
}

export interface PersonalAssetControllerDeleteRequest {
    id: string;
}

export interface PersonalAssetControllerDeleteByPortfolioIdRequest {
    portfolioId: string;
    sourceType: string;
}

export interface PersonalAssetControllerGetRequest {
    id: string;
}

export interface PersonalAssetControllerGetListRequest {
    portfolioId: string;
    sourceType: string;
    limit: number;
    offset: number;
}

export interface PersonalAssetControllerImportRequest {
    importType: PersonalAssetImportTypeEnum;
    personalAssetsFile?: Blob;
}

export interface PersonalAssetControllerUpdateRequest {
    id: string;
    updatePersonalAssetDto: UpdatePersonalAssetDto;
}

/**
 * 
 */
export class PersonalAssetsApi extends runtime.BaseAPI {

    /**
     * Create personal asset
     */
    async personalAssetControllerCreateRaw(requestParameters: PersonalAssetControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetDto>> {
        if (requestParameters.createPersonalAssetDto === null || requestParameters.createPersonalAssetDto === undefined) {
            throw new runtime.RequiredError('createPersonalAssetDto','Required parameter requestParameters.createPersonalAssetDto was null or undefined when calling personalAssetControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePersonalAssetDtoToJSON(requestParameters.createPersonalAssetDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetDtoFromJSON(jsonValue));
    }

    /**
     * Create personal asset
     */
    async personalAssetControllerCreate(requestParameters: PersonalAssetControllerCreateRequest, initOverrides?: RequestInit): Promise<PersonalAssetDto> {
        const response = await this.personalAssetControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove personal asset
     */
    async personalAssetControllerDeleteRaw(requestParameters: PersonalAssetControllerDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Remove personal asset
     */
    async personalAssetControllerDelete(requestParameters: PersonalAssetControllerDeleteRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.personalAssetControllerDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove personal asset
     */
    async personalAssetControllerDeleteByPortfolioIdRaw(requestParameters: PersonalAssetControllerDeleteByPortfolioIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.portfolioId === null || requestParameters.portfolioId === undefined) {
            throw new runtime.RequiredError('portfolioId','Required parameter requestParameters.portfolioId was null or undefined when calling personalAssetControllerDeleteByPortfolioId.');
        }

        if (requestParameters.sourceType === null || requestParameters.sourceType === undefined) {
            throw new runtime.RequiredError('sourceType','Required parameter requestParameters.sourceType was null or undefined when calling personalAssetControllerDeleteByPortfolioId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets/by-portfolio/{portfolioId}/{sourceType}`.replace(`{${"portfolioId"}}`, encodeURIComponent(String(requestParameters.portfolioId))).replace(`{${"sourceType"}}`, encodeURIComponent(String(requestParameters.sourceType))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Remove personal asset
     */
    async personalAssetControllerDeleteByPortfolioId(requestParameters: PersonalAssetControllerDeleteByPortfolioIdRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.personalAssetControllerDeleteByPortfolioIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get by personal asset
     */
    async personalAssetControllerGetRaw(requestParameters: PersonalAssetControllerGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetWithValueDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetControllerGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetWithValueDtoFromJSON(jsonValue));
    }

    /**
     * Get by personal asset
     */
    async personalAssetControllerGet(requestParameters: PersonalAssetControllerGetRequest, initOverrides?: RequestInit): Promise<PersonalAssetWithValueDto> {
        const response = await this.personalAssetControllerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get array of personal assets
     */
    async personalAssetControllerGetListRaw(requestParameters: PersonalAssetControllerGetListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetListDto>> {
        if (requestParameters.portfolioId === null || requestParameters.portfolioId === undefined) {
            throw new runtime.RequiredError('portfolioId','Required parameter requestParameters.portfolioId was null or undefined when calling personalAssetControllerGetList.');
        }

        if (requestParameters.sourceType === null || requestParameters.sourceType === undefined) {
            throw new runtime.RequiredError('sourceType','Required parameter requestParameters.sourceType was null or undefined when calling personalAssetControllerGetList.');
        }

        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling personalAssetControllerGetList.');
        }

        if (requestParameters.offset === null || requestParameters.offset === undefined) {
            throw new runtime.RequiredError('offset','Required parameter requestParameters.offset was null or undefined when calling personalAssetControllerGetList.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets/list/{portfolioId}/{sourceType}`.replace(`{${"portfolioId"}}`, encodeURIComponent(String(requestParameters.portfolioId))).replace(`{${"sourceType"}}`, encodeURIComponent(String(requestParameters.sourceType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetListDtoFromJSON(jsonValue));
    }

    /**
     * Get array of personal assets
     */
    async personalAssetControllerGetList(requestParameters: PersonalAssetControllerGetListRequest, initOverrides?: RequestInit): Promise<PersonalAssetListDto> {
        const response = await this.personalAssetControllerGetListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Import personalAsset(s) from file
     */
    async personalAssetControllerImportRaw(requestParameters: PersonalAssetControllerImportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ImportPersonalAssetsResultDto>> {
        if (requestParameters.importType === null || requestParameters.importType === undefined) {
            throw new runtime.RequiredError('importType','Required parameter requestParameters.importType was null or undefined when calling personalAssetControllerImport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.personalAssetsFile !== undefined) {
            formParams.append('personalAssetsFile', requestParameters.personalAssetsFile as any);
        }

        const response = await this.request({
            path: `/api/personal-assets/{importType}`.replace(`{${"importType"}}`, encodeURIComponent(String(requestParameters.importType))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportPersonalAssetsResultDtoFromJSON(jsonValue));
    }

    /**
     * Import personalAsset(s) from file
     */
    async personalAssetControllerImport(requestParameters: PersonalAssetControllerImportRequest, initOverrides?: RequestInit): Promise<ImportPersonalAssetsResultDto> {
        const response = await this.personalAssetControllerImportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update personal asset
     */
    async personalAssetControllerUpdateRaw(requestParameters: PersonalAssetControllerUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetControllerUpdate.');
        }

        if (requestParameters.updatePersonalAssetDto === null || requestParameters.updatePersonalAssetDto === undefined) {
            throw new runtime.RequiredError('updatePersonalAssetDto','Required parameter requestParameters.updatePersonalAssetDto was null or undefined when calling personalAssetControllerUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePersonalAssetDtoToJSON(requestParameters.updatePersonalAssetDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetDtoFromJSON(jsonValue));
    }

    /**
     * Update personal asset
     */
    async personalAssetControllerUpdate(requestParameters: PersonalAssetControllerUpdateRequest, initOverrides?: RequestInit): Promise<PersonalAssetDto> {
        const response = await this.personalAssetControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
